export default function () {
  if (window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.match(/iPad|iPhone|iPod/)) {
    return true;
  } else {
    return false;
  }
}
